export const APPLICATION_ERROR = 'Application'
export const NOT_FOUND_ERROR = 'Not Found'

export class ApplicationError extends Error {
  constructor(message) {
    super(message)
    this.type = APPLICATION_ERROR
    this.message = message
    this.code = 500
  }
}

export class NotFoundError extends Error {
  constructor(message) {
    super(message)
    this.type = NOT_FOUND_ERROR
    this.message = message
    this.code = 404
  }
}
